export default {"src":"/_next/static/media/closeIcon.2e268c2c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};